import './slider.scss'

class PhotoSlider {
    element = null

    containerSelector = '.ui-shops__swiper-container'
    slideSelector = '.ui-shops__swiper-photo'
    count = 0
    slides = []
    current = 0
    interval = 3000
    intervalId = null

    dotsSelector = '.ui-shops__swiper-dots'
    dotSelector = '.ui-shops__swiper-dot'
    dots = []

    arrowPrevSelector = '.ui-shops__swiper-prev'
    arrowNextSelector = '.ui-shops__swiper-next'
    arrowPrev = null
    arrowNext = null
    
    constructor(element, options={}) {
        this.element = element

        this.slides = this.element.querySelector(this.containerSelector).querySelectorAll(this.slideSelector)
        this.count = this.slides.length

        if (this.count === 0) return

        this.dots = this.element.querySelector(this.dotsSelector).querySelectorAll(this.dotSelector)

        this.arrowPrev = this.element.querySelector(this.arrowPrevSelector)
        this.arrowNext = this.element.querySelector(this.arrowNextSelector)

        if (options.interval > 0) {
            this.interval = options.interval
        }

        this.setEvents()
        this.setAutoplay()
    }

    next() {
        let nextSlide = this.current + 1

        if (nextSlide > this.count - 1) {
            nextSlide = 0
        }

        this.set(nextSlide)
    }

    prev() {
        let prevSlide = this.current - 1

        if (prevSlide < 0) {
            prevSlide = this.count - 1
        }

        this.set(prevSlide)
    }

    set(slideNumber) {
        this.slides[this.current].style.display = 'none'
        this.slides[slideNumber].style.display = 'block'

        this.dots[this.current].classList.remove('ui-shops__swiper-dot_active')
        this.dots[slideNumber].classList.add('ui-shops__swiper-dot_active')

        this.current = slideNumber
    }

    setAutoplay() {
        this.intervalId = setInterval(() => {
            this.next()
        }, this.interval)
    }

    stopAutoplay() {
        clearInterval(this.intervalId)
    }

    setEvents() {
        this.dots.forEach((dot) => {
            dot.addEventListener('click', () => {
                const n = +dot.getAttribute('data-slide')

                this.set(n)
            })
        })

        this.element.addEventListener('mouseover', () => {
            this.stopAutoplay()
        })

        this.element.addEventListener('mouseout', () => {
            this.setAutoplay()
        })

        this.arrowPrev.addEventListener('click', () => {
            this.prev()
        })

        this.arrowNext.addEventListener('click', () => {
            this.next()
        })
    }
}

export default PhotoSlider